import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Chip,
} from "@mui/material";
import { fetchNotifications } from "../features/authSlice";
import MainLayout from "../components/MainLayout";

export default function NotificationsPage() {
  const dispatch = useDispatch();

  const notifications = useSelector((state) => state.auth.notifications);
  const next = useSelector((state) => state.auth.nextPage);
  const previous = useSelector((state) => state.auth.previousPage);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  return (
    <MainLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: "bold" }}>
          الإشعارات
        </Typography>

        {notifications.length === 0 && (
          <Typography
            sx={{
              textAlign: "center",
              mt: 5,
              fontSize: "1.2rem",
              color: "text.secondary",
            }}
          >
            لا يوجد إشعارات حالياً 👌
          </Typography>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {notifications.map((n) => {
            const payload = n.payload_json || {};

            const typeIcons = {
              order: "📦",
              status: "⚙️",
              message: "💬",
              default: "🔔",
            };

            const icon = typeIcons[n.type] || typeIcons.default;

            return (
              <Card
                key={n.id}
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                  background: n.seen ? "#ffffff" : "#e8f4ff",
                  transition: "0.25s",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-3px)",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                  },
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* Icon + Title */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography sx={{ fontSize: "1.6rem" }}>
                        {icon}
                      </Typography>
                      <Chip
                        label={n.type}
                        color="primary"
                        size="small"
                        sx={{ fontWeight: "bold" }}
                      />
                    </Box>

                    {/* Date */}
                    <Typography variant="caption" color="text.secondary">
                      {new Date(n.sent_at).toLocaleString("ar-EG")}
                    </Typography>
                  </Box>

                  {/* Message */}
                  <Typography sx={{ mt: 2, fontSize: "1.05rem" }}>
                    {payload.message || "لديك إشعار جديد"}
                  </Typography>

                  {/* Extra Fields */}
                  <Box sx={{ mt: 2, color: "text.secondary" }}>
                    {payload.order_id && (
                      <Typography variant="body2">
                        رقم الطلب: <strong>{payload.order_id}</strong>
                      </Typography>
                    )}

                    {payload.service && (
                      <Typography variant="body2">
                        الخدمة: <strong>{payload.service}</strong>
                      </Typography>
                    )}
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Box>

        {/* Pagination */}
        <Box
          sx={{
            mt: 4,
            display: "flex",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            disabled={!previous}
            onClick={() => dispatch(fetchNotifications(previous))}
            sx={{ px: 4, borderRadius: 2 }}
          >
            السابق
          </Button>

          <Button
            variant="contained"
            color="primary"
            disabled={!next}
            onClick={() => dispatch(fetchNotifications(next))}
            sx={{ px: 4, borderRadius: 2 }}
          >
            التالي
          </Button>
        </Box>
      </Box>
    </MainLayout>
  );
}
